import InvoicePositionBase, { IGetInvoicePositionBaseDto, InvoicePositionProcessingType } from "./InvoicePositionBase"
import dayjs, { Dayjs } from "utils/dayjs"
import { Guid } from "@/types"

export const RESERVATION_INVOICE_POSITION_TEXT_LINE_BREAK_AFTER = 55

export interface IGetReservationInvoicePositionDto extends IGetInvoicePositionBaseDto {
    reservationInvoicePositionId: Guid
    isAdHoc: boolean
    amount: number
    processingType?: InvoicePositionProcessingType | null
    start?: string | null
    end?: string | null
    invoicedDate?: string | null
}

export default class ReservationInvoicePosition extends InvoicePositionBase {
    reservationInvoicePositionId: Guid
    isAdHoc: boolean
    amount: number
    processingType?: InvoicePositionProcessingType
    start?: Dayjs
    end?: Dayjs
    invoicedDate?: Dayjs
    constructor(dto: IGetReservationInvoicePositionDto) {
        super(dto)
        this.reservationInvoicePositionId = dto.reservationInvoicePositionId
        this.isAdHoc = dto.isAdHoc
        this.amount = dto.amount
        this.processingType = dto.processingType || undefined
        this.start = dto.start ? dayjs.utc(dto.start, "YYYY-MM-DD").startOf('date') : undefined
        this.end = dto.end ? dayjs.utc(dto.end, "YYYY-MM-DD").startOf('date') : undefined
        this.invoicedDate = dto.invoicedDate ? dayjs.utc(dto.invoicedDate, "YYYY-MM-DD").startOf('date') : undefined
    }

}
